import axios from "./config";
import { API } from "./api";

export const getDistrictList = async () => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.districtList}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getStoreNoList = async () => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.storeNumberList}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getlaborCodeList = async () => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.laborCodeList}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const addExceptionPrice = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.addPrice}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getstatusList = async () => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.statusList}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const searchSubmitService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.searchSubmit}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const updatePricingService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.updatePricing}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const approveRejectService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.approveRejectPricing}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const verifyCurrentRatesService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.verifyCurrentRates}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getExceptionPricesList = async (body) => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.exceptionPrices}`, { params: body })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getPriceService = async (id, storeNum) => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.getPrices.replace("{0}", id).replace("{1}", storeNum)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const editPriceService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.editprice}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const deletePriceService = async (body) => {
  return axios
    .post(`${API.laborTable.root}${API.laborTable.deletePrice}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const showExpPriceService = async (storeNum) => {
  return axios
    .get(`${API.laborTable.root}${API.laborTable.showExpPrice.replace("{0}", storeNum)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};
